module.exports = __webpack_public_path__ + "static/Black-4d795924d523c9d8d45540e67370465a.png";